import styled from 'styled-components';

export const Wrapper = styled.div`
  && {
    background-color: white;
    .section {
      padding: 25px 40px;
    }
    .header-choose {
      height: 80px;
      background-color: rgba(236, 255, 184, 1);
      padding: 0 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .wrap-date {
        display: flex;
        align-items: center;
        .date {
          margin: 0;
        }
        .btn-update-bill {
          background-color: #ff5222;
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
          width: 174px;
          height: 48px;
          border-radius: 5px;
          border: none;
          color: white;
        }
      }
    }
    .info {
      margin-left: 30px;
      background-color: white;
      padding: 5px 10px 5px 10px;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
    }
    .table {
      margin-top: 40px;
    }
  }
`;
